var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.count)?_c('v-badge',{attrs:{"color":"primary","inline":""},scopedSlots:_vm._u([{key:"badge",fn:function(){return [_vm._v(" "+_vm._s(_vm.count)+" ")]},proxy:true}],null,false,3301152278)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }